import React from "react";

import { ContentCopy as CopyIcon, Web as WebIcon } from "@mui/icons-material";
import { Typography, Box, Button, Alert, Paper, Divider, CircularProgress } from "@mui/material";

import { MainLayout } from "../components/layout/MainLayout";
import { CACard } from "../components/ui";
import { useNotification } from "../contexts/NotificationContext";
import { useServiceAdditionalInfo } from "../hooks";
import type { RootState } from "../store";
import { useAppSelector } from "../store/hooks";

export const WebsiteContentPage: React.FC = () => {
  const selectedService = useAppSelector((state: RootState) => state.service.selectedService);
  const { showSuccess, showError } = useNotification();
  const { data: additionalInfo, isLoading: isLoadingAdditionalInfo } = useServiceAdditionalInfo(
    selectedService?.serviceId ?? null,
  );

  const schoolUrl = `https://campaustralia.com.au/school/?accessCode=${selectedService?.accessCode}`;

  const generateHtmlContent = () => {
    if (
      (selectedService?.isNationalProgramEnabled && additionalInfo?.hasUpcomingNationalDayPrograms) ||
      (!selectedService?.isNationalProgramEnabled && additionalInfo?.hasUpcomingHolidayProgramDays)
    ) {
      return `<a href='https://www.campaustralia.com.au/'><img alt='Camp Australia. Guiding children&apos;s growth.' src='http://www.campaustralia.com.au/MailContent/Schools/CampAustralia_Logo.png' width='230px' /></a><p style='text-align:Left;'><span style='font-size:x-large; font-family:Arial, Helvetica, sans-serif; color:#000000;'><strong>Camp Australia – Guiding Children&apos;s Growth </strong></span><br /><br /><span style='font-size:medium; font-family:Arial, Helvetica, sans-serif; color:#000000; line-height:normal;'>We are proud to partner with Camp Australia to provide our Outside School Hours Care (OSHC) program. <br /><br />Camp Australia programs are centred on child enrichment, while ensuring a reliable, engaging and hassle-free OSHC service at our school. Their engaged educators foster a safe, inclusive environment where children can relax, have fun and grow. </span><br /><br /><a href=' https://www.campaustralia.com.au/families/oshc'><img alt='Your OSHC. OSHC that inspires.' src='http://www.campaustralia.com.au/MailContent/Schools/YourOSHC_Logo_purple.png' width='150px' /></a></p><p style='text-align:Left;'><span style='font-size:x-large; font-family:Arial, Helvetica, sans-serif; color:#000000;'><strong><i>Your OSHC</i> – OSHC that inspires </strong></span><br /><br /><span style='font-size:medium; font-family:Arial, Helvetica, sans-serif; color:#000000; line-height:normal;'>At <i>Your OSHC</i> by Camp Australia, every before school, after school and pupil free day program is tailored to the likes and interests of each child in service. Camp Australia&apos;s educators design enriching experiences to inspire your children&apos;s confidence, independence and imagination. In any one week, they could be participating in science experiments, active play, creative expression and more - they believe in learning through experience so that each child can grow. </span><br /><br /><a href=' https://www.campaustralia.com.au/families/rocketeers'><img alt='Rocketeers. Extraordinary Holiday Adventures.' src='http://www.campaustralia.com.au/MailContent/Rocketeers/Generic/rocketeers-notag-300pxW.png' width='270px' /></a></p><p style='text-align:Left;'><span style='font-size:x-large; font-family:Arial, Helvetica, sans-serif; color:#000000;'><strong><i>Rocketeers</i> – Extraordinary Holiday Adventures </strong></span><br /><br /><span style='font-size:medium; font-family:Arial, Helvetica, sans-serif; color:#000000; line-height:normal;'><i>Rocketeers</i> by Camp Australia is a space for children to escape the ordinary and experience the extraordinary during their school holidays. Every school holiday break is a new mission for children to embark upon. With carefully designed programs, directed by the children and informed by family feedback, no two days are the same with <i>Rocketeers</i>. Experiences planned could include games, arts & crafts, sport, excursions, cooking, coding and more.</span></p><p><span style='font-size:medium; font-family:Arial, Helvetica, sans-serif; color:#000000;'><b>Click <a href='${schoolUrl}' style='color:#000000'>here</a> to find out more about Camp Australia&apos;s program at our school, including hours of operation and fees. To attend care, you must register your child. <a href='https://pp.campaustralia.com.au/account/register-contacts/' style='color:#000000'>Register now for free.</a></b></span></p>`;
    } else {
      return `<a href='https://www.campaustralia.com.au/'><img alt='Camp Australia. Guiding children&apos;s growth.' src='http://www.campaustralia.com.au/MailContent/Schools/CampAustralia_Logo.png' width='230px' /></a><p style='text-align:Left;'><span style='font-size:x-large; font-family:Arial, Helvetica, sans-serif; color:#000000;'><strong>Camp Australia – Guiding Children's Growth </strong></span><br /><br /><span style='font-size:medium; font-family:Arial, Helvetica, sans-serif; color:#000000; line-height:normal;'>We are proud to partner with Camp Australia to provide our Outside School Hours Care (OSHC) program.<br /><br />Camp Australia programs are centred on child enrichment, while ensuring a reliable, engaging and hassle-free OSHC service at our school. Their engaged educators foster a safe, inclusive environment where children can relax, have fun and grow.</span></p><br /><br /><a href=' https://www.campaustralia.com.au/families/oshc'><img alt='Your OSHC. OSHC that inspires.' src='http://www.campaustralia.com.au/MailContent/Schools/YourOSHC_Logo_purple.png' width='150px' /></a><p style='text-align:Left;'><span style='font-size:x-large; font-family:Arial, Helvetica, sans-serif; color:#000000;'><strong><i>Your OSHC</i> – OSHC that inspires</strong></span><br /><br /><span style='font-size:medium; font-family:Arial, Helvetica, sans-serif; color:#000000; line-height:normal;'>At <i>Your OSHC</i> by Camp Australia, every before school, after school and pupil free day program is tailored to the likes and interests of each child in service. Camp Australia's educators design enriching experiences to inspire your children's confidence, independence and imagination. In any one week, they could be participating in science experiments, active play, creative expression and more - they believe in learning through experience so that each child can grow.</span></p><p><br /><span style='font-size:medium; font-family:Arial, Helvetica, sans-serif; color:#000000;'><b>Click <a href='${schoolUrl}' style='color:#000000'>here</a> to find out more about Camp Australia&apos;s program at our school, including hours of operation and fees. To attend care, you must register your child. <a href='https://pp.campaustralia.com.au/account/register-contacts/' style='color:#000000'>Register now for free.</a></b></span></p>`;
    }
  };

  const htmlContent = generateHtmlContent();

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(htmlContent);
      showSuccess("HTML content copied to clipboard!");
    } catch (err) {
      console.error("Failed to copy text: ", err);
      showError("Failed to copy HTML content. Please try again.");
    }
  };

  return (
    <MainLayout>
      <Box sx={{ p: 3 }}>
        <CACard sx={{ mb: 3 }}>
          <Box sx={{ padding: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
              <WebIcon color="secondary" />
              <Typography variant="h6">
                Direct website link to the Camp Australia Outside School Hours Care program at your school
              </Typography>
            </Box>

            <Typography variant="body1" sx={{ mb: 2 }}>
              Below you will find the direct link for the Camp Australia Outside School Hours Care program at{" "}
              <strong>{selectedService?.serviceName}</strong>.
            </Typography>

            <Typography variant="body1" sx={{ mb: 3 }}>
              We kindly ask if you could please place the HTML content (below) onto your school webpage. The direct link
              allows parents to access information about the Camp Australia Outside School Hours Care program at{" "}
              <strong>{selectedService?.serviceName}</strong>, including hours of operation, fees and registration.
            </Typography>

            <Alert severity="info" sx={{ mb: 3 }}>
              <Typography variant="subtitle2" gutterBottom>
                Direct link to your school's program:
              </Typography>
              <Typography variant="body2" sx={{ wordBreak: "break-all" }}>
                {schoolUrl}
              </Typography>
            </Alert>
          </Box>
        </CACard>

        <CACard>
          <Box sx={{ padding: 2 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
              <Typography variant="h6">HTML content to place in your website:</Typography>
              <Button
                variant="outlined"
                color="secondary"
                startIcon={<CopyIcon />}
                onClick={copyToClipboard}
                size="small"
              >
                Copy HTML
              </Button>
            </Box>

            <Divider sx={{ mb: 2 }} />

            <Paper variant="outlined" sx={{ p: 2, backgroundColor: "#f5f5f5" }}>
              <Typography
                variant="body2"
                component="pre"
                sx={{
                  fontFamily: "monospace",
                  fontSize: "1rem", // Changed from 0.75rem (12px) to 1rem (16px) for mobile accessibility
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-all",
                  margin: 0,
                }}
              >
                {htmlContent}
              </Typography>
            </Paper>

            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
              Copy and paste the HTML code above into your school's website where you want the Camp Australia
              information to appear.
            </Typography>
          </Box>
        </CACard>

        {!selectedService && (
          <CACard sx={{ mt: 3 }}>
            <Box sx={{ padding: 2 }}>
              <Typography variant="body1" color="text.secondary" align="center">
                Please select a service to generate website content.
              </Typography>
            </Box>
          </CACard>
        )}

        {selectedService && isLoadingAdditionalInfo && (
          <CACard sx={{ mt: 3 }}>
            <Box sx={{ padding: 2, display: "flex", justifyContent: "center", alignItems: "center" }}>
              <CircularProgress size={24} sx={{ mr: 2 }} />
              <Typography variant="body1" color="text.secondary">
                Loading additional service information...
              </Typography>
            </Box>
          </CACard>
        )}
      </Box>
    </MainLayout>
  );
};
